import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71188574")

_pushScopeId("data-v-71188574")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "写跟进", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_5 = {
  class: "flex button-group",
  style: {"justify-content":"center"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = { class: "flex flexR mar-t-22" }
const _hoisted_9 = { class: "flex flexC form" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogFormVisible = true))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "164"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  class: "btn",
                  onClick: ($event: any) => (_ctx.btnClick(scope.row.id, true))
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "btn",
                  onClick: ($event: any) => (_ctx.btnClick(scope.row.id, false))
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "写跟进",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: ""
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            ref: "formRef",
            "label-width": "150px"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, {
                label: "客户",
                rules: [{ required: true, message: '请输入跟进客户' }]
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, null, {
                    default: _withId(() => [
                      _createVNode(_component_el_option)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "跟进类型" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.type = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_option, {
                        label: "电话",
                        value: "1"
                      }),
                      _createVNode(_component_el_option, {
                        label: "微信",
                        value: "2"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "跟进内容" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"280px"},
                    type: "textarea",
                    rows: 2,
                    modelValue: _ctx.form.content,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.content = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})